export default abstract class RegexLibrary {

    public static email    = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    public static password = /^(?=.*[!@#\$&\(\)\-])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[!@#\$&\(\)\-[0-9a-zA-Z]{8,}$/;
    public static nifLegal = /[A-Z]/;
    public static numberTest = /^[0-9]*$/;
    public static numberReplace = /[^0-9]/g;
  
}